import { useMutation } from "@apollo/client";

import { GqlMapEditorLayerDeleteInput, gql } from "~/__generated__";

import { ProjectMapEditorScreen_GetProjectDocument } from "../../project/screens/ProjectMapEditorScreen/queries.generated";
import { MapEditorGetAllLayerFeaturesDocument } from "./useMapEditorGetAllLayerFeatures.generated";

const MAP_EDITOR_LAYER_DELETE = gql(`
    mutation MapEditorLayerDelete($input: GqlMapEditorLayerDeleteInput!) {
        mapEditorLayerDelete(input: $input)
    }
`);

export default function useMapEditorLayerDelete() {
    const [layerDelete, { data, loading, error }] = useMutation(MAP_EDITOR_LAYER_DELETE, {
        refetchQueries: [MapEditorGetAllLayerFeaturesDocument, ProjectMapEditorScreen_GetProjectDocument],
    });

    return {
        layerDelete: (input: GqlMapEditorLayerDeleteInput) =>
            layerDelete({
                variables: { input },
            }),
        loading,
        error,
        data: data?.mapEditorLayerDelete,
    };
}
